import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import searchAnimation from '../images/search.lottie';

const LottieLoader = ({ size = 400, speed = 1, animation = searchAnimation }) => {
  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    margin: '0 auto'
  };

  return (
    <div style={containerStyle}>
      <DotLottieReact
        src={animation}
        loop
        autoplay
        speed={speed}
      />
    </div>
  );
};

export default LottieLoader;
